<div>
  @if (listsLoading()) {
    <div class="flex justify-center p-4">
      <mat-spinner></mat-spinner>
    </div>
  } @else if (listsError()) {
    <div class="flex justify-center p-4">
      <p class="text-red-500">{{ errorText }}</p>
    </div>
  } @else {
    <div class="overflow-x-auto">
      <table
        mat-table
        [dataSource]="dataSource"
        [matSortActive]="currentSort.active"
        [matSortDirection]="currentSort.direction"
        matSort
        (matSortChange)="sortData($event)"
        class="w-full"
      >
        <!-- List Name Column -->
        <ng-container matColumnDef="listName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="border-b p-4 text-left">
            List Name
          </th>
          <td mat-cell *matCellDef="let list" class="border-b p-4">
            {{ list.listName }}
          </td>
        </ng-container>

        <!-- Date Created Column -->
        <ng-container matColumnDef="dateCreated">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="border-b p-4 text-left">
            Date Created
          </th>
          <td mat-cell *matCellDef="let list" class="border-b p-4">
            {{ list.dateCreated | date: CONFIG.date.createdDateFormat }}
          </td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let row" class="!text-right">
            <div class="hover:opacity-100">
              <button mat-icon-button (click)="openEditModal(row); $event.stopPropagation()">
                <mat-icon>edit</mat-icon>
              </button>
              <button mat-icon-button (click)="openDeleteModal(row); $event.stopPropagation()">
                <mat-icon>delete</mat-icon>
              </button>
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr
          mat-row
          *matRowDef="let row; columns: displayedColumns"
          [routerLink]="['/orders', row.id, 'view-list']"
          class="hover:bg-gray-100 cursor-pointer list-row"
        ></tr>
      </table>
    </div>

    <ciwc-pagination
      [currentPage]="currentPage"
      [pageSize]="pageSize"
      [totalItems]="totalLists"
      [pageSizeOptions]="pageSizeOptions"
      (pageChange)="handlePageEvent($event)"
    ></ciwc-pagination>

    <!-- Hidden paginator for functionality -->
    <div class="hidden">
      <mat-paginator
        #paginator
        [length]="totalLists"
        [pageSize]="pageSize"
        [pageSizeOptions]="pageSizeOptions"
        (page)="handlePageEvent($event)"
        aria-label="Select page"
      >
      </mat-paginator>
    </div>
  }
</div>
